import React, { useState, useEffect } from "react";
import { Tabs, Typography, Flex, Switch, message } from "antd";
import CreateSolution from "./CreateSolution";
import CreateSolutionStageTwo from "./CreateSolutionStageTwo";
import orderService from "../../services/OrderLists";
import usePermissions from "../../hooks/usePermissions";
import { useParams } from "react-router-dom";
function CreateSolutionParent({
  setIsModalVisible,
  getSolutionFiles,
  setRenderStatic,
  fetchOrderDetails,
}) {
  const { TabPane } = Tabs;
  const { orderKey } = useParams();

  const { hasPermission } = usePermissions();
  const [subscribers, setSubscribers] = useState([]);
  const [fileTypes, setFileTypes] = useState([]);
  const [feedbackDropdownData, setFeedbackDropdownData] = useState([]);

  const [solutionFiles, setSolutionFiles] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [formData, setFormData] = useState({
    files: [],
    file_type: "",
    remarks: "",
    feedback_uids: [],
    // quality_check_completed: undefined,
    // grammarly_check_completed: undefined,
    // proofreading_completed: undefined,
    // author_details_removed: undefined,
    ai_report_added: undefined,
    plag_report_added: undefined,
    task_type: "",
    word_count_achieved: undefined,
    english_country: "",
    english_country_other: "",
    referencing_format: "",
    referencing_format_other: "",
    submission_file_format: "",
    expert_rating: undefined,
  });
  const [solutionFormdataStageTwo, setSolutionFormdataStageTwo] = useState({
    file_uids: [],
    subscribers: [],
  });
  const [dropdownData, setDropdownData] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [description, setDescription] = useState("");
  const [selectedRadio, setSelectedRadio] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const handleRadioChange = (value) => {
    setSelectedRadio(value);
  };
  const handleSubscriberChange = (username) => {
    setSolutionFormdataStageTwo((prevData) => ({
      ...prevData,
      subscribers: prevData.subscribers.includes(username)
        ? prevData.subscribers.filter((subscriber) => subscriber !== username) // Remove if already selected
        : [...prevData.subscribers, username], // Add if not selected
    }));
  };

  // console.log("loading=1==1=1",loading)
  // const handleSwitchChange = (checked) => {
  //   setFormData({ ...formData, is_partial_work: checked });
  // };
  useEffect(() => {
    try {
      // setLoading(true);
      if (activeTabKey === "1") {
        setLoading(true);
        const getFileTypes = async () => {
          const fileTypesResponse = await orderService.getSolutionFilesTypes();
          const feedbackDropdownResponse =
            await orderService.getFeedbackdropDown(orderKey);

          if (fileTypesResponse.success && feedbackDropdownResponse.success) {
            // setLoading(false);
            setFileTypes(fileTypesResponse?.data);
            setFeedbackDropdownData(feedbackDropdownResponse?.data);
            setLoading(false);
          }
        };
        getFileTypes();
      } else if (activeTabKey === "2") {
        setLoading(true);
        const getFileList = async () => {
          const response = await orderService.getSolutionSubscribers(orderKey);
          const getFileListResponse = await orderService.getFileList(orderKey);
          if (response.success && getFileListResponse.success) {
            setSubscribers(response?.data?.data);

            setSolutionFiles(getFileListResponse?.data?.data);
            setLoading(false);
          }
        };
        getFileList();
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }, [activeTabKey]);

  const handleFileChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);

    // Extract only the originFileObj from each file entry
    const files = newFileList.map((file) => file.originFileObj).filter(Boolean);

    setFormData((prevData) => ({
      ...prevData,
      files: files,
    }));
  };
  const handleDeleteFile = (index) => {
    const updatedFileList = [...fileList];
    updatedFileList.splice(index, 1); // Remove the file at the specified index
    setFileList(updatedFileList); // Update the state with the new file list

    // Update formData.files to remove the corresponding file
    const updatedFiles = [...formData.files];
    updatedFiles.splice(index, 1); // Remove the file at the specified index
    setFormData((prevData) => ({ ...prevData, files: updatedFiles })); // Update files in formData
  };

  const handleTabChange = (key) => {
    setActiveTabKey(key);
  };

  const handleCreateSolution = async () => {
    try {
      setIsSubmitLoading(true);

      if (activeTabKey === "1") {
        // ===============================
        // VALIDATION
        // ===============================
        const missing = [];

        if (!formData.files || formData.files.length === 0)
          missing.push("Files");

        if (
          formData.files &&
          formData.files.some((f) => !f.file_type)
        )
          missing.push("File Type (for all files)");

        if (!formData.remarks) missing.push("Remarks");
        if (!formData.task_type) missing.push("Task Type");

        if (
          formData.word_count_achieved === undefined ||
          formData.word_count_achieved === null
        )
          missing.push("Word Count Achieved");

        if (!formData.english_country) missing.push("English Country");

        if (
          formData.english_country === "other" &&
          !formData.english_country_other
        )
          missing.push("English Country (Other)");

        if (!formData.referencing_format)
          missing.push("Referencing Format");

        if (
          formData.referencing_format === "other" &&
          !formData.referencing_format_other
        )
          missing.push("Referencing Format (Other)");

        if (!formData.submission_file_format)
          missing.push("Submission File Format");

        if (formData.ai_report_added === undefined)
          missing.push("AI Report Added");

        if (formData.plag_report_added === undefined)
          missing.push("Plag Report Added");

        if (
          formData.expert_rating === undefined ||
          formData.expert_rating === null
        )
          missing.push("Expert Rating");

        if (missing.length) {
          message.error(`Please provide: ${missing.join(", ")}`);
          setIsSubmitLoading(false);
          return;
        }

        // ===============================
        // FORMDATA
        // ===============================
        const data = new FormData();

        data.append("remarks", formData.remarks);
        data.append("task_type", formData.task_type);
        data.append(
          "word_count_achieved",
          String(formData.word_count_achieved)
        );
        data.append("english_country", formData.english_country);

        if (formData.english_country === "other") {
          data.append(
            "english_country_other",
            formData.english_country_other || ""
          );
        }

        data.append("referencing_format", formData.referencing_format);

        if (formData.referencing_format === "other") {
          data.append(
            "referencing_format_other",
            formData.referencing_format_other || ""
          );
        }

        data.append(
          "submission_file_format",
          formData.submission_file_format
        );

        data.append(
          "ai_report_added",
          String(formData.ai_report_added)
        );

        data.append(
          "plag_report_added",
          String(formData.plag_report_added)
        );

        data.append("expert_rating", String(formData.expert_rating));

        // ===============================
        // FEEDBACK
        // ===============================
        if (formData.feedback_uids?.length) {
          formData.feedback_uids.forEach((uid) => {
            data.append("feedback_uids", uid);
          });
        }

        // ===============================
        // FILES (PER-FILE TYPE)
        // ===============================
        formData.files.forEach((item, index) => {
          data.append(`files[${index}][file]`, item.file);
          data.append(`files[${index}][file_type]`, item.file_type);
        });

        // ===============================
        // API CALL
        // ===============================
        const response = await orderService.createSolutionStageOne(
          orderKey,
          data
        );

        if (response.success) {
          setFormData({
            files: [],
            remarks: "",
            feedback_uids: [],
            ai_report_added: undefined,
            plag_report_added: undefined,
            task_type: "",
            word_count_achieved: undefined,
            english_country: "",
            english_country_other: "",
            referencing_format: "",
            referencing_format_other: "",
            submission_file_format: "",
            expert_rating: undefined,
          });

          setFileList([]);
          message.success("Solution created successfully");

          setRenderStatic(true);
          await getSolutionFiles();
          setActiveTabKey("2");
        }
      }

      // ===============================
      // STAGE 2 (UNCHANGED)
      // ===============================
      if (activeTabKey === "2") {
        const response =
          await orderService.createSolutionStageTwo(
            orderKey,
            solutionFormdataStageTwo
          );

        if (response.success) {
          message.success("Files added successfully");
          fetchOrderDetails();
          setIsModalVisible(false);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitLoading(false);
    }
  };

  return (
    <div>
      <Tabs
        activeKey={activeTabKey}
        onChange={handleTabChange}
      // tabBarExtraContent={
      //   activeTabKey === "1" && (
      //     <div style={{ display: "flex", alignItems: "center" }}>
      //       <label style={{ marginRight: "8px" }}>Work Is Partial</label>
      //       <Switch
      //         checked={formData.is_partial_work}
      //         onChange={handleSwitchChange}
      //       />
      //     </div>
      //   )
      // }
      >
        <TabPane tab="Add Solution" key="1">
          <CreateSolution
            fileTypes={fileTypes}
            formData={formData}
            onSubmit={handleCreateSolution}
            loading={loading}
            fileList={fileList}
            setFileList={setFileList}
            handleFileChange={handleFileChange}
            handleDeleteFile={handleDeleteFile}
            setFormData={setFormData}
            isSubmitLoading={isSubmitLoading}
            feedbackDropdownData={feedbackDropdownData}
          />
        </TabPane>
        {hasPermission("can_view_order_action_add_solution") && (
          <TabPane tab="Files List" key="2">
            <CreateSolutionStageTwo
              solutionFiles={solutionFiles}
              subscribers={subscribers}
              solutionFormdataStageTwo={solutionFormdataStageTwo}
              loading={loading}
              setSolutionFormdataStageTwo={setSolutionFormdataStageTwo}
              handleSubscriberChange={handleSubscriberChange}
              handleRadioChange={handleRadioChange}
              onSubmit={handleCreateSolution}
              isSubmitLoading={isSubmitLoading}
            />
          </TabPane>
        )}
      </Tabs>
    </div>
  );
}

export default CreateSolutionParent;
